import { ApiClient } from '@api'

export class SignForwardApiClient {
    constructor(protected apiClient: ApiClient) { }

    public getEligibility = (cvr: string, agreementCode: number) => {
        const url = `api/SignForward/eligibility?cvr=${encodeURIComponent(cvr)}&agreementCode=${agreementCode}`
        return this.apiClient.get<boolean>(url).then(x => x.data === true)
    }
}
